<template>
  <refonte-page-alert
    v-bind:description_in_card="true"
    v-bind:alert_type="'error'"
    v-bind:end_date="'2026-11-05T01:30:00'">
    Bonjour,<br />
    Dans le cadre d’une opération technique,
    <b
      >les espaces JINIUS seront temporairement indisponibles le mercredi 4
      novembre de 19h à 24h</b
    >. <br />Durant cette période, il ne sera pas possible d’accéder aux
    portails ni aux services associés. Le rétablissement du service est prévu
    <b>à partir de 01h30 .</b><br />
    Nous vous remercions pour votre compréhension et vous prions de nous excuser
    pour la gêne occasionnée.<br />
    L’équipe JINIUS
  </refonte-page-alert>
  <navigation
    v-bind:sub_components_list="subComponentsList"
    v-bind:labels="labels"
    v-bind:default_key="'sessions'"
    v-bind:sync_with_route="true" />
</template>

<script setup lang="ts">
  import navigation from '@/views/_espace/_refonte/formateur/utils/navigation.vue';

  import sessions from '@/views/_espace/_refonte/formateur/_sessions/sessions.vue';
  import sessionsdone from '@/views/_espace/_refonte/formateur/_sessions/sessionsdone.vue';
  import RefontePageAlert from '@/components/refonte/alerts/refonte-page-alert.vue';

  const labels: Record<string, string> = {
    sessionsdone: 'Sessions terminées',
    sessions: 'Prochaines sessions'
  };

  const subComponentsList = {
    sessions,
    sessionsdone
  };
</script>

<style lang="scss" scoped></style>
